import { SpinProps } from 'antd';
import * as S from './SpinSlump.styles';
import { ReactComponent as SpinnerSupermix } from '@app/assets/icons/loadingSlump.svg';

export const SpinnerSlump: React.FC<SpinProps> = (props) => {
  return <S.Spinner {...props} indicator={<SpinnerSupermix />} />;
};
